export default __webpack_public_path__ + "c7cf14764e97719df01d2cc0d6f131a8.png";